<template>
  <div class="createPointControl-wrapper">
    <headView v-if="$route.params.id" class="disable-add-user" :option="editUserObj" :subtitleOpt="subtitleOpt"></headView>
    <headView v-else class="disable-add-user" :option="createUserObj" :subtitleOpt="subtitleOpt"></headView>
    <div class="createPointControl_body">
        
        <div class="wrap-btn-content-CP">
          <div class="buttons">
              <div class="button-actionControl" @click="backToListCP">
                <i class="material-icons">remove_circle_outline</i><span>Cancelar</span>
              </div>
              <div class="button-actionControl" @click="backToListCP" v-if="$route.params.id">
                <i class="material-icons">highlight_off</i><span>Eliminar Punto de Control</span>
              </div>
          </div>
          </div>
      <form-wizard  @on-complete="completeW"
                    title=""
                    subtitle=""
                    color="#1FB6FF"
                    errorColor="#d0021b"
                    next-button-text="Siguiente"
                    back-button-text="Atrás"
                    finish-button-text="Finalizar"
                    :startIndex="indexStart"
                    class="form-wizard-custom">
        <tab-content  title="Detalle del Punto de Control"
                      icon="ti-plus"
                      :beforeChange="completedCP">
          <crea-c-p/>
        </tab-content>
        <tab-content title="Lista de Tareas"
                      icon="ti-menu-alt"
                      :beforeChange="completeTS">
          <tasks/>
        </tab-content>
        <tab-content title="Edificios"
                      icon="ti-home">
          <edificio-c-p :viewActive="viewLocal"/>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import { service } from "@/helper/Rest";
import CreaCP from "../Main/controlPointIn";
import EdificioCP from "../Main/PuntoControlEdificio";
import Tasks from "../Main/listaTareas";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "createControlPoint",
  components: {
    headView,
    CreaCP,
    EdificioCP,
    Tasks
  },
  data() {
    return {
      createUserObj: {
        headText: "Puntos de Control",
        subtitle: "Nuevo Punto de Control",
        btnAction: false
      },
      subtitleOpt: true,
      editUserObj: {
        headText: "Puntos de Control",
        subtitle: "Editar Punto de Control",
        btnAction: false
      },
      startIndex: 0,
      viewLocal: 'controlPoint'
    };
  },
  created() {
    if(this.cp_id){
      this.$store.dispatch("GETCHECKPOINT", {id_company: this.company_id, id_checkpoint: this.cp_id}).then(r => {
        this.$store.dispatch("GETTASKS", r.id) 
      })
    }
  },
  watch: {},
  computed: {
    ...mapGetters([
      "edificios",
      "imageTemp",
      "company_id",
      "newControlPoint",
      "cp_id"
    ]),
    indexStart: function() {
      if(this.$localStorage.get("creaId")){
        this.startIndex = this.$localStorage.get("creaId")
      }
      return Number(this.startIndex);
    }
  },
  beforeDestroy(){
    this.$store.commit("resetCP_id")
    this.$store.commit("resetNewControlPoint")
  },
  methods: {
    ...mapMutations([]),
    ...mapActions({
      postCP: "POSTCHECKPOINT"
    }),
    backToControlPoint: function() {
      this.$router.push("puntocontrol");
    },
    success() {
      this.$toast.open({
        message: "Punto de control creado",
        position: "is-bottom-right",
        type: "ffcolor-is-success"
      });
    },
    // Executed when @completed-step event is triggered
    completedCP: function() {
      return new Promise((r, d) => {
        console.log({newCP: this.newControlPoint});
        
        if (this.newControlPoint.flag) {
          this.$store
            .dispatch("POSTCHECKPOINT", {
              id_company: this.company_id,
              obj: this.newControlPoint
            })
            .then(cp => {
              this.$store.commit("resetImageTemp");
              this.$store.dispatch("GETTASKS", cp.id)
              this.success();
              this.$localStorage.set("creaId", '1')
              r(true);
            })
            .catch(err => {
              r(false);
            });
        } else {
          this.$store.commit("resetImageTemp");
          this.$store.commit("resetCurrentCP");
          this.backToListCP()
          return false;
        }
      });
    },
    completeTS: function() {
      this.$store.commit("resetTasks");
      this.$localStorage.set("creaId", '2')
      return true;
    },
    backToListCP: function() {
      this.$router.push({ name: "puntocontrol" });
      this.$store.commit("resetCurrentCP");
      this.$localStorage.remove("creaId")
    },
    completeW: function() {
      this.$store.commit("resetCP_id")
      this.backToListCP();
      return true;
    }
  }
};
</script>
<style lang="scss">
.vue-form-wizard {
  padding-bottom: 20px;
  margin: auto;
  width: 1000px;
}
</style>

<style lang="scss" scoped>
@import "../../assets/styles/2.tools/mixins/_navegators.scss";
.createPointControl-wrapper {
  height: 100%;
}
.createPointControl_body {
  height: 100%;
  padding-top: 70px;
  padding-left: 30px;
  padding-right: 30px;
}
.wrapper-checkPoint-body {
  max-width: 500px;
}
.body_header {
  width: 100%;
}
.header_title {
  font-size: 25px;
  font-weight: bold;
  text-align: start;
  margin: 0;
  padding-left: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.header {
  font-size: 25px;
  font-weight: bold;
  text-align: start;
  padding: 10px 0;
  // margin: 25px;
}
.footer_controlpoint {
  margin: 25px 0;
  // width: 675px;
}
.icon-download {
  color: dodgerblue;
  transform: scale(0.9);
}
// .input-custom{
//   input{
//     height: 3.25em !important;
//   }
// }
.custom-stepper {
  margin: auto;
  margin-top: 20px;
  padding-top: 10px;
  max-width: 800px;
  @include navegators(0 0 0 rgba(0, 0, 0, 0));
  .content {
    padding: 0 30px;
  }
}
.wrap-btn-content-CP {
  position: relative;
  width: 800px;
  margin: auto;
  display: flex;
  justify-content: flex-end;
  .buttons{
    margin: 10px;
    // width: 40%;
  }
  &__options {
    position: relative;
    left: 100%;
    transform: translateX(-100%);
    width: 30%;
  }
}
.wrap-btn-content {
  padding: 10px 0;
  display: flex;
  flex-flow: row wrap;
  width: 500px;
  margin: auto;
  justify-content: space-between;
  .btn-action {
    border-radius: 3px;
    width: 220px;
    // margin-left: 0;
    // margin-right: 0;
  }
  &--one {
    margin-left: 0;
    margin-right: 10px;
    background-color: #c9c9c9;
  }
  &--two {
    margin-right: 0;
    margin-left: 10px;
    background-color: #1abc9c;
  }
  &--three {
    // margin-right: 0;
    // margin-left: 10px;
    background-color: #d0021b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/createControlPoint.vue